import React from "react";

import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Chip
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";

import { useNavigate } from "react-router-dom";

const ProductCard = ({
  product,
  cartItem,
  addToCart,
  updateQuantity
}) => {
  const navigate = useNavigate();
  const quantity = cartItem?.quantity || 0;

  const handleViewDetails = () => {
    navigate(`/product/${product._id}`);
  };

  const handleCartAction = async (action) => {
    try {
      await action();
    } catch (err) {
      if (err.message === "NOT_AUTHENTICATED") {
        const existing = JSON.parse(localStorage.getItem("pendingCart")) || [];
        const index = existing.findIndex((item) => item.productId === product._id);

        if (index > -1) existing[index].quantity += 1;
        else existing.push({ productId: product._id, quantity: 1 });

        localStorage.setItem("pendingCart", JSON.stringify(existing));
        navigate("/login");
      } else {
        console.error(err);
      }
    }
  };

  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        minHeight: { xs: 390, md: 430 },
        display: "flex",
        flexDirection: "column",
        borderRadius: { xs: "14px", md: "18px" },
        overflow: "hidden",
        position: "relative",
        background: "#fff",
        border: "1px solid rgba(139,0,0,0.1)",
        boxShadow: "0 8px 20px rgba(139,0,0,0.08)",
        transition: "0.25s",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 14px 28px rgba(139,0,0,0.14)"
        }
      }}
    >
      <Box sx={{ position: "absolute", top: 10, left: 10, zIndex: 2 }}>
        <Chip icon={<LocalFireDepartmentIcon />} label="Fresh" size="small" sx={{ background: "#8B0000", color: "#fff", fontWeight: 700 }} />
      </Box>

      <Box
        sx={{
          background: "#fff8f5",
          height: { xs: 170, md: 190 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2
        }}
      >
        <CardMedia
          component="img"
          image={product.image || "https://via.placeholder.com/250"}
          alt={product.name}
          onClick={handleViewDetails}
          sx={{ width: "100%", height: "100%", objectFit: "contain", cursor: "pointer" }}
        />
      </Box>

      <CardContent sx={{ p: 2, display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <Typography sx={{ color: "#8B0000", fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", mb: 0.5 }}>
          {product.category}
        </Typography>

        <Typography sx={{ fontWeight: 700, color: "#2b2b2b", mb: 0.8, fontSize: { xs: "0.95rem", md: "1rem" }, minHeight: 46 }}>
          {product.name}
        </Typography>

        <Typography sx={{ color: "#666", fontSize: "0.82rem", lineHeight: 1.6, mb: 1.2, minHeight: 58 }}>
          {product.description?.substring(0, 90)}
        </Typography>

        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
          <Typography sx={{ color: "#8B0000", fontWeight: 800, fontSize: { xs: "1.05rem", md: "1.15rem" } }}>
            ₹{Number(product.price).toFixed(2)}
          </Typography>
          <Button size="small" onClick={handleViewDetails} sx={{ textTransform: "none", color: "#8B0000", fontWeight: 600 }}>
            View Details
          </Button>
        </Box>

        {quantity > 0 ? (
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mt: "auto", border: "1px solid #e6d1cd", borderRadius: "10px", p: 0.7 }}>
            <Button size="small" onClick={() => handleCartAction(() => updateQuantity(product._id, quantity - 1))}><RemoveIcon fontSize="small" /></Button>
            <Typography sx={{ fontWeight: 700 }}>{quantity}</Typography>
            <Button size="small" onClick={() => handleCartAction(() => updateQuantity(product._id, quantity + 1))}><AddIcon fontSize="small" /></Button>
          </Box>
        ) : (
          <Button
            fullWidth
            variant="contained"
            startIcon={<ShoppingCartIcon />}
            onClick={() => handleCartAction(() => addToCart(product))}
            sx={{ mt: "auto", borderRadius: "10px", textTransform: "none", background: "#8B0000" }}
          >
            Add to Cart
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default ProductCard;
